import { images } from "../constants";

const testimonials = [  
    { 
        id: 1,
        image: images.testimonial1, 
        name: 'Emily Parker', 
        title: 'Outdoor Enthusiast',
        content: 'Each trek was an adventure through the wilderness, connecting me deeply with nature and leaving me with a sense of awe and wonder. The attention to detail and the bond formed with the environment were exceptional.'
    }, 
    { 
        id: 2,
        image: images.testimonial2, 
        name: 'John Smith', 
        title: 'Nature Lover',
        content: "Trekking through the wilderness was like embarking on a soul-stirring journey. The freedom and connection with nature made me feel alive and in harmony with the world. It's an experience that I'll cherish forever."
    },
    { 
        id: 3,
        image: images.testimonial3, 
        name: 'Sarah Johnson', 
        title: 'Trailblazer',
        content: 'Trekking is a thrilling adventure that offers a unique blend of challenge and serenity. The bond formed with nature and the beauty of the surroundings create an unforgettable experience that leaves me longing for more.'
    },    
    { 
        id: 4,
        image: images.testimonial4, 
        name: 'Michael Brown', 
        title: 'Outdoor Explorer',
        content: "Trekking with the club was an eye-opening experience, offering a diverse range of trails and landscapes that appealed to all adventurers. From tranquil forests to challenging mountain paths, each trek offered a new perspective on nature's beauty."
    },
];

export default testimonials;